import { graphql } from 'react-relay';

import OnpageRoutes from './routes/onpage';
import HttpStatusRoutes from './routes/http-status';
import IndexingRoutes from './routes/indexing';
import CanonicalRoutes from './routes/canonical';
import EcommerceRoutes from './routes/ecommerce';

import { createRenderFunction } from './utils/redirects';
import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'crawler/:url',
  async getComponent (nextState) {
    const {
      default: CrawlerContainer
    } = await import(/* webpackChunkName: "crawler-contianer" */ './containers/CrawlerContainer')
      .catch(handleChunkLoadError);
    return CrawlerContainer;
  },
  children: [{
    path: '',
    query: graphql`
      query crawler_CrawlerPage_Query($host: String!) {
        project(host: $host) {
          ...CrawlerPage_project
        }
      }
    `,
    prepareVariables: params => ({ ...params, host: params.url }),
    async getComponent (nextState) {
      const {
        default: Crawler
      } = await import(/* webpackChunkName: "crawler" */ './containers/CrawlerPage')
        .catch(handleChunkLoadError);
      return Crawler;
    },
    renderReady: createRenderFunction({ redirectTo: '/on-page/title-issues' }),
    children: [
      OnpageRoutes,
      HttpStatusRoutes,
      IndexingRoutes,
      CanonicalRoutes,
      EcommerceRoutes
    ]
  }]
});
